import {
    DELETE_PENDING_PAYOUTS_FAILURE,
    DELETE_PENDING_PAYOUTS_LOAD,
    DELETE_PENDING_PAYOUTS_SUCCESS,
    PENDING_PAYOUTS_FAILURE,
    PENDING_PAYOUTS_LOAD,
    PENDING_PAYOUTS_SUCCESS
} from './pendingPayoutsActions';
import {
    get,
    isEqual
} from 'lodash';
import { createSelector } from 'reselect';
import { getEntityByName } from '../appEntities';

export default function reducer(state = {}, action = {}) {
    let newState;

    switch (action.type) {
        case PENDING_PAYOUTS_LOAD:
            newState = {
                ...state,
                pendingPayouts: [],
                error: null,
                isLoading: true
            };

            return isEqual(state, newState) ? state : newState;

        case PENDING_PAYOUTS_SUCCESS:
            newState = {
                ...state,
                pendingPayouts: action.pendingPayouts,
                count: action.count,
                isLoading: false,
                pages: action.pages,
                hasMore: action.hasMore,
                offset: action.offset,
                limit: action.limit
            };

            return isEqual(state, newState) ? state : newState;

        case PENDING_PAYOUTS_FAILURE:
            newState = {
                ...state,
                count: 0,
                error: action.error,
                isLoading: false,
                pages: 0
            };

            return isEqual(state, newState) ? state : newState;

        case DELETE_PENDING_PAYOUTS_LOAD:
            newState = {
                ...state,
                wasDeletePendingPayoutsSuccessful: false,
                isDeletePendingPayoutsLoading: true,
                deletePendingPayoutsError: null
            };

            return isEqual(state, newState) ? state : newState;

        case DELETE_PENDING_PAYOUTS_SUCCESS:
            newState = {
                ...state,
                deletePendingPayoutsError: null,
                wasDeletePendingPayoutsSuccessful: true,
                isDeletePendingPayoutsLoading: false
            };

            return isEqual(state, newState) ? state : newState;

        case DELETE_PENDING_PAYOUTS_FAILURE:
            newState = {
                ...state,
                deletePendingPayoutsError: action.error,
                wasDeletePendingPayoutsSuccessful: false,
                isDeletePendingPayoutsLoading: false
            };

            return isEqual(state, newState) ? state : newState;
        default:
            return state;
    }
}

export const getPendingPayoutsEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'pendingPayouts')
);

export const getPages = createSelector(
    getPendingPayoutsEntity,
    (entity) => get(entity, 'pages')
);

export const getCount = createSelector(
    getPendingPayoutsEntity,
    (entity) => get(entity, 'count')
);

export const getIsPendingPayoutsLoading = createSelector(
    getPendingPayoutsEntity,
    (entity) => get(entity, 'isLoading')
);

export const getPendingPayouts = createSelector(
    getPendingPayoutsEntity,
    (entity) => get(entity, 'pendingPayouts')
);

export const getPendingPayoutsError = createSelector(
    getPendingPayoutsEntity,
    (entity) => get(entity, 'error')
);

export const getPendingPayoutsErrorMessage = createSelector(
    getPendingPayoutsError,
    (error) => get(error, 'message')
);

export const getHasMore = createSelector(
    getPendingPayoutsEntity,
    (entity) => get(entity, 'hasMore')
);

export const getWasDeletePendingPayoutsSuccessful = createSelector(
    getPendingPayoutsEntity,
    (entity) => get(entity, 'wasDeletePendingPayoutsSuccessful')
);

export const getIsDeletePendingPayoutsLoading = createSelector(
    getPendingPayoutsEntity,
    (entity) => get(entity, 'isDeletePendingPayoutsLoading')
);

export const getDeletePendingPayoutsError = createSelector(
    getPendingPayoutsEntity,
    (entity) => get(entity, 'deletePendingPayoutsError')
);

export const getDeletePendingPayoutsErrorMessage = createSelector(
    getPendingPayoutsError,
    (error) => get(error, 'message')
);
